import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import utils from 'utils';
import useActions from 'hooks/useActions';
import { getAlamoContactUsSupportPhoneNumber } from 'selectors/supportSelectors';
import { getSupportContactInfo } from 'actions/content';
import CUSTOMER_SUPPORT from 'constants/customerSupport';
import { isFetchingEndpointSelector } from 'selectors/fetchingSelectors';

const { PHONE_TYPE } = CUSTOMER_SUPPORT;

/**
 * useSupportPhoneNumber - Get support phone number based on country domain
 * @return {string} support phone number
 */
const useSupportPhoneNumber = ({ hasDisabilities = false } = {}) => {
  const domainCountry = utils.config.getDomainCountry();
  const getSupportContactInfoHandler = useActions(getSupportContactInfo);
  const supportPhone = useSelector((state) => getAlamoContactUsSupportPhoneNumber(state, domainCountry))?.phone_number;
  const isFetchingContactInfo = useSelector((state) =>
    isFetchingEndpointSelector(state, { endpoint: 'support/contact' })
  );
  const [supportPhoneVal, setsupportPhoneVal] = useState(supportPhone);

  useEffect(() => {
    const dispatchReduxAction = async () => {
      // Retrieve Support Contact if no support phone available.
      if (!supportPhone && !isFetchingContactInfo)
        await getSupportContactInfoHandler(domainCountry).then((data) => {
          const phoneType = hasDisabilities ? PHONE_TYPE.DISABILITIES : PHONE_TYPE.CONTACT_US;
          const contactPhone = data?.support_phone_numbers?.find((phoneNum) => phoneNum?.phone_type === phoneType);

          if (contactPhone?.phone_number) {
            setsupportPhoneVal(contactPhone?.phone_number);
          }
        });
    };

    dispatchReduxAction();
  }, []);

  return supportPhoneVal;
};

export default useSupportPhoneNumber;
